import React from 'react';
import PropTypes from 'prop-types';

import Shimmer from 'components/Shimmer';

const TableLoading = ({ rows = 10 }) => {
  return (
    <div className="d-flex flex-column gap-2 mb-3">
      <Shimmer height="2.5rem" />
      {Array.from({ length: rows }, (_, index) => (
        <Shimmer key={index} height="3rem" />
      ))}
    </div>
  );
};

TableLoading.propTypes = {
  rows: PropTypes.number,
};

export default TableLoading;
